module.exports = "/images/aerial-9.jpg";